<template>
  <v-row class="box-container ma-0 pa-0" v-bind="$attrs">
    <v-dialog right v-model="isExportWindowVisible" max-width="300px" value="isExportWindowVisible" style="overflow: hidden">
      <v-container class="ma-0 pa-0" style="overflow: hidden">
        <v-card class="ma-0 pa-0" align-items="center">
          <v-card-title class="ma-2 pa-0">
            <v-row class="ma-0 pa-0" justify="center" align="center">
              <v-spacer></v-spacer>
              <span class="ma-2 subtitle-1">Експортиране</span>
              <v-spacer></v-spacer>
              <v-btn color="error" :rounded="true" density="compact" @click="isExportWindowVisible = false" icon="mdi-close"> </v-btn>
            </v-row>
          </v-card-title>
          <v-select class="pa-3" density="compact" :items="exportFormats" item-value="csv" v-model="exportFormat" label="Формат"></v-select>
          <v-row justify="center" class="ma-0 pa-2 pb-2">
            <v-btn block :color="isInDarkMode ? '' : 'grey lighten-3'" tile class="elevation-0" @click="exportTable">
              <span>Изтегли</span>
              <v-icon right color="success">mdi-arrow-down-bold</v-icon>
            </v-btn>
          </v-row>
        </v-card>
      </v-container>
    </v-dialog>
    <v-row v-if="!isLoading" class="row-header ma-0 pa-0">
      <slot name="top"></slot>
      <!-- <v-btn v-if="datatype && datatype.add" class="ma-1" variant="outlined" @click="add()" :class="IF.MyFont">
        <v-icon>mdi-plus</v-icon>
        <span v-if="!isOnMobile">{{ "Нов " + datatype.name }}</span>
      </v-btn>
      <v-btn v-if="datatype && datatype.edit" :disabled="!selectedItem" class="ma-1" variant="outlined" @click="edit(selectedItem)" :class="IF.MyFont">
        <v-icon>mdi-pencil</v-icon>
        <span v-if="!isOnMobile">{{ "Редактирай " + datatype.name }}</span>
      </v-btn> -->

      <t-date-range-input
        v-if="showPeriod && datatype && datatype.dates"
        class="ma-1"
        :width="200"
        :max-width="200"
        v-model="datatype.dates"
        label="Период"
        title="Период"
        :clearable="false"
        @change="reloadData()"
      ></t-date-range-input>
      <v-spacer></v-spacer>
      <t-btn v-if="showExport" class="ma-1" small @click="showExportWindow()">
        <span class="mr-2" v-if="!isOnMobile">Експортиране</span>
        <v-icon>mdi-download</v-icon>
      </t-btn>
      <t-btn v-if="showExport" class="ma-1" small @click="selectColumns()">
        <span class="mr-2" v-if="!isOnMobile">Колони</span>
        <v-icon>mdi-format-columns</v-icon>
      </t-btn>
    </v-row>
    <div class="row-content pa-0 elevation-3" ref="refGridContainer" style="max-he" :class="isOnMobile ? 'ma-0' : ' ma-2'">
      <v-data-table-virtual
        id="virtual-scroll-table"
        class="ma-0 pa-0 elevation-0 customscroll"
        :class="IF.MyFont"
        ref="refGrid"
        :row-props="getRowProps"
        v-model="selectedItems"
        v-model:group-by="groupBy"
        v-model:sort-by="sortBy"
        v-model:sort-desc="sortDesc"
        v-scroll:#scroll-target="onScroll"
        :group-desc="false"
        :headers="getHeaders"
        :items="getData"
        :key="getData.length"
        :loading="isLoading"
        :density="IF.Density"
        locale="bg-BG"
        :mobile-breakpoint="0"
        :height="gridHeight"
        fixed-header
        hide-default-footer
        loading-text="Данните се зареждат, моля изчакайте..."
        @click:row="setSelected"
      >
        <template v-slot:no-data>
          <div align="center">
            <!-- <v-icon class="ma-2 pa-2">mdi-emoticon-sad</v-icon> -->
            <span align="center" justify="start" :style="`color: gray;`">{{ noDataMessage }}</span>
          </div>
        </template>
        <template v-slot:[`header.${h.value}`] v-for="(h, hix) in getHeaders" :key="hix">
          <div
            v-if="h.value == 'my_custom_id' || h.value == 'edit' || h.value == 'delete' || h.value == 'NotSeen'"
            :style="`max-height: ${gridHeadersHeight}px; height: ${gridHeadersHeight}px;`"
          >
            {{ h.text }}
          </div>
          <div v-else @click="headerClick(h)" :style="'cursor: pointer; max-height: ' + gridHeadersHeight + 'px; height: ' + gridHeadersHeight + 'px;'">
            <div :style="'height: ' + rowHeight + 'px;'">
              <div :style="'display: flex; justify-content: center; align-items: center; height: ' + rowHeight + 'px;'">
                <v-icon v-if="headerIsSorted(h)" small>{{ getHeaderSortIcon(h) }}</v-icon>
                <v-chip v-if="headerIsSorted(h) && IF.MultiSort" x-small style="cursor: pointer">{{ headerNumber(h) }}</v-chip>
                <span class="mx-1" style="white-space: pre">{{ h.text }}</span>
                <v-tooltip :disabled="hideTooltips" location="top">
                  <template v-slot:activator="{ props }">
                    <template v-if="h.canBeGrouped">
                      <v-icon v-if="headerIsGrouped(h)" v-bind="props" @click.stop="removeGrouping()" small>mdi-minus-box-multiple-outline</v-icon>
                      <v-icon v-else v-bind="props" @click.stop="headerGroupingClick(h)" small>mdi-plus-box-multiple-outline</v-icon>
                    </template>
                  </template>
                  <span>{{ headerIsGrouped(h) ? "Премахни групирането" : " Групирай по " + h.text }}</span>
                </v-tooltip>
              </div>
            </div>
            <div v-if="isFilterMenuVisible" class="flex-grow-0" :style="'display: flex; min-width: 100%; height: ' + 40 + 'px;'" @click.stop="">
              <t-date-range-input
                v-if="h.proptype == DataPropType.Date || h.proptype == DataPropType.DateShort"
                @change="refreshData()"
                class="ma-0 pa-0 caption flex-grow-1"
                v-model="h.filtervalues"
                :title="h.text"
                :clearable="true"
                :append-inner-icon="h.filtervalues[0] ? '' : 'mdi-calendar-month'"
              >
              </t-date-range-input>
              <t-checkbox
                v-else-if="h.proptype == DataPropType.BOOL"
                @change="refreshData()"
                v-model="h.filtervalues[0]"
                class="ma-0 mx-auto pa-0"
                single-line
                hide-details
                density="compact"
                yesValue="Да"
                noValue="Не"
              >
              </t-checkbox>
              <v-select
                v-else-if="h.filtertype.id == DataFilterType.In.id"
                class="myselect ma-0 pa-0 caption"
                v-model="h.filtervalues"
                @update:modelValue="refreshData()"
                :items="getFiltersUniqueValues(h)"
                :height="rowHeight"
                :item-title="(i) => i.toString()"
                :item-color="isInDarkMode ? '#FFFFFF' : ''"
                no-data-text="Липсват данни"
                return-object
                multiple
                clearable
                single-line
                width="auto"
                :min-width="150"
                density="compact"
              >
                <template v-slot:selection="{ item, index }">
                  <v-tooltip :disabled="hideTooltips" location="bottom">
                    <template v-slot:activator="{ props }">
                      <span v-if="index == 0 && item" v-bind="props" class="ma-0 pa-0" :class="IF.MyFont" style="white-space: pre">{{
                        h.filtervalues.join(", ").length > 20 ? h.filtervalues.join(", ").substring(0, 19) + "…" : h.filtervalues.join(", ")
                      }}</span>
                    </template>
                    <span class="mylabel subtitle-2" style="white-space: pre">{{ h.filtervalues ? h.filtervalues.join("\n") : "" }}</span>
                  </v-tooltip>
                </template>

                <!-- <template #item="{ item, index, props: { onClick } }">
                  <v-list-item @click="onClick">
                    <t-check-box :modelValue="h.filtervalues[index]" @change="check(item, index)"></t-check-box>
                    <span :class="IF.MyFont">{{ item.title }}</span>
                  </v-list-item>
                </template> -->
                <!-- <template v-slot:label>
                  <span class="mylabel subtitle-2">{{ h.filtervalues ? h.filtervalues.join("\n") : "" }}</span>
                </template> -->
              </v-select>
              <t-number-range-input
                v-else-if="
                  h.proptype == DataPropType.Number ||
                  h.proptype == DataPropType.Money ||
                  h.proptype == DataPropType.QTY ||
                  h.proptype == DataPropType.Money4digits ||
                  h.proptype == DataPropType.Identificator
                "
                class="mytextfield ma-0 pa-0 subtitle-2 flex-grow-1"
                v-model="h.filtervalues"
                @change="refreshData()"
                full-width
                hide-details
                single-line
                clearable
                density="compact"
                :outlined="true"
                :height="rowHeight"
              >
              </t-number-range-input>
              <v-text-field
                v-else
                class="mytextfield ma-0 pa-0 subtitle-2"
                v-model="h.filtervalues[0]"
                @change="refreshData()"
                @click:clear="refreshData()"
                hide-details
                density="compact"
                single-line
                clearable
                outlined
                :height="rowHeight"
              >
                <template v-slot:label>
                  <span class="mylabel subtitle-2">{{ h.filtervalues[0] ? "" + h.filtervalues[0] : "" }}</span>
                </template>
                <template v-if="!h.filtervalues[0]" v-slot:append-inner>
                  <v-icon>mdi-magnify</v-icon>
                </template>
              </v-text-field>
            </div>
            <div v-if="hasGridHeaderSum" class="flex-grow-0 ma-0 pa-0 mt-2" :style="`height: ${rowHeight}px;`" @click.stop="">
              <span
                class="data-grid-cell"
                style="font-weight: bold"
                :style="h.cell_align == 'center' ? 'justify-content: center;' : 'justify-content: flex-' + h.cell_align + ';'"
              >
                {{ h.summable ? formatCell(h, getTotalSum(h.value)) : "" }}
              </span>
            </div>
          </div>
        </template>
        <!-- <template v-slot:[`header.data-table-group`]></template> -->
        <template v-slot:group-header="{ item, columns, toggleGroup, isGroupOpen }">
          <tr>
            <td :colspan="columns.length" @click="toggleGroup(item)" style="cursor: pointer; justify-items: center">
              <v-tooltip :disabled="hideTooltips" location="top">
                <template v-slot:activator="{ props }">
                  <v-icon v-bind="props" @click.stop="toggleGroup(item)" class="mr-4">{{ isGroupOpen ? "mdi-menu-right" : "mdi-menu-down" }} </v-icon>
                </template>
                <span>{{ isGroupOpen(item) ? "Скрий" : "Покажи" }}</span>
              </v-tooltip>
              <!-- <span>{{ getHeaders.find((h) => h.value == groupBy[0]).text + ":   " + group }}</span> -->
              <span class="subtitle-2">{{ (item.value ?? "-") + " (" + item.items.length + ")" }}</span>
              <!-- <v-tooltip :disabled="hideTooltips" location="top">
                <template v-slot:activator="{ props }">
                  <v-icon v-bind="props" @click="removeGrouping()" class="ml-4">{{ "mdi-minus" }} </v-icon>
                </template>
                <span>Премахни групирането</span>
              </v-tooltip> -->
            </td>
          </tr>
        </template>
        <!-- <template v-slot:item="{ item }" >
          <tr :style="item.isSelected ? 'background: ' + Color.IconColor : ''" @contextmenu.stop="showContextMenu($event, item)"></tr>
        </template> -->
        <template v-slot:[`item.${h.value}`]="{ item }" v-for="(h, ndx) in getHeaders" :key="ndx">
          <span v-if="h.value == 'my_custom_id'" class="data-grid-cell" style="justify-content: center">
            {{ item.my_custom_id + startRow - extraBottom + 1 }}
          </span>
          <!-- <v-icon v-else-if="h.value == 'isOnline'" class="data-grid-cell" :color="Object.byString(item, h.value) ? 'success' : ''">mdi-head</v-icon> -->
          <span
            v-else-if="h.proptype == DataPropType.Color"
            class="data-grid-cell"
            :style="
              (h.cell_align == 'center' ? 'justify-content: center;' : 'justify-content: flex-' + h.cell_align) +
              '; background: ' +
              Object.byString(item, h.value)
            "
          >
            {{ formatCell(h, Object.byString(item, h.value)) }}
          </span>
          <span
            v-else-if="Object.byString(item, h.value) && !!Object.byString(item, h.value).Color"
            class="data-grid-cell"
            style="justify-content: center"
            :style="
              (h.cell_align == 'center' ? 'justify-content: center;' : 'justify-content: flex-' + h.cell_align) +
              ';background: ' +
              Object.byString(item, h.value).Color
            "
          >
            {{ formatCell(h, Object.byString(item, h.value)) }}
          </span>
          <span
            v-else-if="h.isFileOrFolder"
            class="data-grid-cell"
            :style="
              h.cell_align == 'center' ? 'justify-content: center;' : 'justify-content: flex-' + h.cell_align + '; cursor: pointer; text-decoration: underline;'
            "
          >
            {{ formatCell(h, Object.byString(item, h.value)) }}
          </span>
          <span
            v-else-if="h.isLink"
            class="data-grid-cell"
            :style="
              h.cell_align == 'center' ? 'justify-content: center;' : 'justify-content: flex-' + h.cell_align + '; cursor: pointer; text-decoration: underline;'
            "
            @click="
              openInternalLink(h.value.indexOf('.') == -1 ? h.value : h.value.substring(h.value.indexOf('.') + 1, h.value.length), {
                select: Object.byString(item, h.value).Id,
              })
            "
          >
            {{ formatCell(h, Object.byString(item, h.value)) }}
          </span>
          <!-- <v-checkbox
            v-else-if="h.proptype == DataPropType.BOOL"
            :modelValue="Object.byString(item, h.value)"
            
            class="data-grid-cell"
            density="compact"
            :disabled="true"
            :style="h.cell_align == 'center' ? 'justify-content: center;' : 'justify-content: flex-' + h.cell_align"
          >
          </v-checkbox> -->
          <!-- <v-icon v-else-if="h.value == 'edit'" @click="edit(item)">mdi-pencil</v-icon> -->
          <span
            v-else
            @contextmenu="showContextMenu($event, item)"
            class="data-grid-cell"
            :style="h.cell_align == 'center' ? 'justify-content: center;' : 'justify-content: flex-' + h.cell_align"
          >
            {{ formatCell(h, Object.byString(item, h.value)) }}
          </span>
          <!-- <span v-else :key="index" class="data-grid-cell" :style="h.cell_align == 'center' ? 'justify-content: center;' : 'justify-content: flex-' + h.cell_align + ';' + (hasCellClickEvent(h.value) ? ' cursor: pointer; text-decoration: underline;' : '')" @contextmenu.stop="showContextMenu($event, item)" @click="getCellClickEvent($event, item, h.value)">
            {{ formatCell(h, Object.byString(item, h.value)) }}
          </span> -->
        </template>

        <template v-slot:[`item.edit`]="{ item }">
          <!-- <v-row justify="space-between" class="ma-0 pa-0"> -->
          <v-icon @click="edit(item)">mdi-pencil</v-icon>
          <!-- </v-row> -->
        </template>
        <template v-slot:[`item.delete`]="{ item }">
          <v-row justify="space-between" class="ma-0 pa-0">
            <v-icon @click="del(item)">mdi-delete</v-icon>
          </v-row>
        </template>

        <template v-slot:[`item.NotSeen`]="{ item }">
          <v-row justify="space-between" class="ma-0 pa-0" :style="item.NotSeen ? 'background: pink;' : ''" @click.stop.prevent="changeSeenState(item)">
            <v-icon v-if="item.NotSeen == true">mdi-eye-off-outline</v-icon>
            <v-icon v-else-if="item.NotSeen == false" color="success">mdi-eye-check-outline</v-icon>
          </v-row>
        </template>

        <!-- <template v-slot:body v-if="dataitems && dataitems.length > 0">
          <template v-for="(item, iix) in getData">
            <tr :key="iix">
              <td v-for="(h, index) in getHeaders" :key="index" :style="'height: ' + rowHeight + 'px'">
                <span class="data-grid-cell" :style="h.cell_align == 'center' ? 'justify-content: center;' : 'justify-content: flex-' + h.cell_align + ';' + (hasCellClickEvent(h.value) ? ' cursor: pointer; text-decoration: underline;' : '') " @contextmenu.stop="showContextMenu($event, item)" @click="getCellClickEvent($event, item, h.value)">
                  {{ formatCell(h, Object.byString(item, h.value)) }}
                </span>
              </td>
            </tr>
          </template>
        </template>-->

        <!-- <template v-slot:footer :style="'height: ' + rowHeight + 'px'">
         <tr v-if="hasGridHeaderSum">
            <td v-for="(hf, hfidx) in getHeaders" :key="'th' + hfidx" :style="isInDarkMode ? 'border-right: 1px solid #444444; border-bottom: 1px solid #444444;' : 'border-right: 1px solid #dddddd; border-bottom: 1px solid #dddddd;'">
              <span class="data-grid-cell" style="font-weight: bold" :style="hf.cell_align == 'center' ? 'justify-content: center;' : 'justify-content: flex-' + hf.cell_align + ';'">
                {{ hf.summable ? formatCell(hf, getTotalSum(hf.value)) : "" }}
              </span>
            </td>
          </tr>
        </template>-->

        <!-- <template v-slot:[`body.prepend`] v-if="dataitems && dataitems.length > 0 && startRow > extraBottom">
          <tr v-if="startRow > 0">
            <td :colspan="getHeaders.length" :style="'padding-top: ' + getStartHeight + 'px'"></td>
          </tr>
        </template>

        <template v-slot:[`body.append`] v-if="dataitems && dataitems.length > startRow + visibleRows + extraTop">
          <tr>
            <td :colspan="getHeaders.length" :style="'padding-top: ' + getEndHeight + 'px'"></td>
          </tr>
        </template> -->

        <template #bottom></template>
      </v-data-table-virtual>
    </div>

    <v-footer app v-if="datatype && datatype.log" padless inset :height="isFooterVisible ? 300 : 0"> </v-footer>

    <v-menu
      v-model="isContextMenuVisible"
      :position-x="mouseX"
      :position-y="mouseY"
      :style="`position: absolute; left: ${mouseX}px; top: ${mouseY}px;`"
      offset-y
      outline
    >
      <v-list density="compact" variant="outlined" class="ma-0 pa-0">
        <v-list-item v-for="(menu, ixx) in contextMenus" :key="ixx" @click="menu.action()">
          <v-list-item-title class="ma-0 pa-0 pl-2">
            <v-icon :color="Colors.IconColor" size="28">{{ menu.icon }}</v-icon>
            {{ menu.text }}
          </v-list-item-title>
        </v-list-item>

        <v-list-item @click="copyCell()">
          <v-list-item-title class="ma-0 pa-0 pl-2">
            <v-icon :color="Colors.IconColor" size="28">mdi-content-copy</v-icon>
            {{ "Копирай съдържанието на клетката" }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-row>
</template>

<script>
import DataManager from "../data/DataManager";
import { DataFilterType, DataPropType } from "../data/DataFilter";
import RobotoFont from "../assets/fonts/Roboto";
import XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { ref, toRaw } from "vue";
import { g_Dialog } from "@/main";

export default {
  props: {
    type: {
      default: null,
    },
    items: {
      type: Array,
      default: () => [],
    },
    menus: {
      type: Array,
      default: () => [],
    },
    hideFilters: {
      type: Boolean,
      default: false,
    },
    showPeriod: {
      type: Boolean,
      default: true,
    },
    showExport: {
      type: Boolean,
      default: true,
    },
    noDataMessage: {
      type: String,
      default: " Няма данни за показване",
    },
  },
  data() {
    return {
      datatype: this.type,
      dataitems: this.items,
      contextMenus: this.menus,
      selectedItem: this.modelValue,
      isFilterMenuVisible: !this.hideFilters,
      selectedItems: [],
      expanded: [],
      clickedText: "",
      mouseX: 0,
      mouseY: 0,
      onfocus: false,
      sortChanged: false,
      virtualScrollerOffset: 0,
      startRow: 0,
      scrollTimeout: 80,
      scrollTimeoutFn: null,
      extraRecords: 100,
      extraBottom: 0,
      extraTop: 0,
      visibleRows: 25,
      sortBy: [],
      sortDesc: [],
      groupBy: [],
      gridHeight: "400px",
      isContextMenuVisible: false,
      isExportWindowVisible: false,
      exportFormat: "pdf",
      exportFormats: ["pdf", "csv", "xls"],
      DataFilterType: DataFilterType,
      DataPropType: DataPropType,
      recalcTimeout: null,
    };
  },
  computed: {
    activeitembackground() {
      return this.Colors.ActiveItemBackground;
    },
    isLoading() {
      return this.datatype == null || this.datatype.isLoading;
    },
    hasGridHeaderSum() {
      return this.getHeaders.some((h) => h.summable);
    },
    gridHeadersHeight() {
      return (this.isFilterMenuVisible ? 44 : 4) + (this.hasGridHeaderSum ? 2 * this.rowHeight : this.rowHeight);
    },
    getHeaders() {
      return this.datatype ? this.datatype.headers.filter((h) => !h.hidden) : []; //.map((item, index) => ({ my_custom_id: index, ...item }));
    },
    rowHeight() {
      return this.isOnMobile || this.IF.Dense ? 20 + this.IF.Font * 6 : 26 + this.IF.Font * 6;
    },
    // getStartHeight() {
    //   return (this.startRow - this.extraBottom) * this.rowHeight;
    // },
    // getEndHeight() {
    //   return (this.dataitems.length - this.startRow - this.visibleRows - this.extraTop) * this.rowHeight;
    // },
    getData() {
      if (!this.dataitems) {
        //router.push({ name: "login", params: { errors: this.message } });
        // this.dialog.showError(this.message, { location: "center" });
        //alert(this.message);
        return [];
      }
      // this.sortBy.forEach((s, idx) => {
      //   var h = this.datatype.headers.find((h) => h.value == s);
      //   data.sort(h.sort);
      //   if (this.sortDesc[idx]) {
      //     data.reverse();
      //   }
      // });
      return this.dataitems.map((item, index) => ({ my_custom_id: index, ...item }));
      // return this.dataitems.slice(this.startRow - this.extraBottom, this.startRow + this.visibleRows + this.extraTop).map((item, index) => ({ my_custom_id: index, ...item }));
    },
  },
  methods: {
    setSelected(event, row) {
      var item = row.item;
      this.$nextTick(() => {
        if (this.selectedItem != item) {
          this.datatype.selected = item;
          this.selectedItem = item;
          row.toggleSelect({ value: item, selectable: true });
          // row.toggleSelect(true);
        } else {
          this.datatype.selected = null;
          this.selectedItem = null;
          row.toggleSelect({ value: item, selectable: false });
          // row.toggleSelect(false);
        }
      });
    },
    onScroll(e) {
      // debounce if scrolling fast
      //console.log("onscroll");
      if (!e) return;
      if (this.scrollTimeoutFn) clearTimeout(this.scrollTimeoutFn);
      this.scrollTimeoutFn = setTimeout(() => {
        const { scrollTop } = e.target;
        const rows = Math.ceil(scrollTop / this.rowHeight);
        var len = this.dataitems.length;
        this.startRow = len - this.visibleRows < rows ? len - this.visibleRows : rows;
        this.extraTop = this.startRow + this.visibleRows + this.extraRecords > len ? len - (this.startRow + this.visibleRows) : this.extraRecords;
        this.extraBottom = this.startRow - this.extraRecords > 0 ? this.extraRecords : this.startRow;

        this.$nextTick(() => {
          e.target.scrollTop = scrollTop;
          this.virtualScrollerOffset = scrollTop;
        });
      }, this.scrollTimeout);
    },
    async add() {
      if (this.datatype.add) {
        var res = await this.datatype.add();
        if (res) {
          await DataManager.loadData(this.datatype);
          this.refreshData();
        }
      }
    },
    async edit(item) {
      if (this.datatype.edit) {
        var res = await this.datatype.edit(item);
        await DataManager.loadData(this.datatype);
        if (res) {
          this.refreshData();
        }
      }
    },

    // changeSeenState(item) {
    //   var O = { NotSeen: !item.NotSeen };
    //   var path = "";
    //   if (this.datatype == DataManager.data.Build) {
    //     O.Id = item.UserBuild.Id;
    //     path = "Build";
    //   } else if (this.datatype == DataManager.data.Ticket) {
    //     O.Id = item.UserTicket.Id;
    //     path = "Ticket";
    //   }
    //   DataManager.changeSeenState(O, path, (resp) => {
    //     if (resp.success) {
    //       item.NotSeen = !item.NotSeen;
    //       if (item.NotSeen) {
    //         this.datatype.events++;
    //       } else {
    //         this.datatype.events--;
    //       }
    //     }
    //   });
    // },
    // getChanges(val, old_val) {
    //   var changes = [];
    //   Object.keys(val).forEach((k) => {
    //     var obj = Object.byString(val, k);
    //     if (old_val) {
    //       var objOld = Object.byString(old_val, k);
    //       if (obj != objOld) {
    //         var header = this.datatype.headers.find((h) => h.value == k);
    //         changes.push((header ? header.text : k) + " от '" + objOld + "' на '" + obj + "'");
    //         // changes.push(objOld + " => " + obj);
    //       }
    //     } else {
    //       var header2 = this.datatype.headers.find((h) => h.value == k);
    //       changes.push((header2 ? header2.text : k) + ": " + obj);
    //     }
    //   });
    //   return changes.join("; ");
    // },
    // del(item) {
    //   this.dialog.show(
    //     this.dialog.dialog_types.yes_no,
    //     null,
    //     {
    //       title: "Внимание",
    //       text: "Сигурни ли сте, че искате да изтриете обекта?",
    //       buttonYesText: "Да",
    //       buttonNoText: "Не",
    //     },
    //     (confirm) => {
    //       if (confirm) {
    //         DataManager.delete(this.datatype, item, (res) => {
    //           if (res.success) {
    //             DataManager.loadData(this.datatype, () => {
    //               this.$nextTick(() => {
    //                 this.refreshData();
    //               });
    //             });
    //             this.dialog.showInfo("Обекта е изтрит.");
    //           } else {
    //             this.dialog.showError("Грешка при изтриване!\r\n" + res.message);
    //           }
    //         });
    //       } else {
    //         this.dialog.showInfo("Операцията е отказана.");
    //       }
    //     },
    //     null
    //   );
    // },
    headerClick(header) {
      setTimeout(() => {
        var hix = this.sortBy.indexOf(header.value);
        if (hix == -1) {
          if (this.IF.MultiSort) {
            this.sortBy.push(header.value);
            this.sortDesc.push(false);
          } else {
            this.sortBy = [header.value];
            this.sortDesc = [false];
          }
        } else {
          if (this.sortDesc[hix] == false) {
            this.sortDesc[hix] = true;
          } else {
            this.sortDesc.splice(hix, 1);
            this.sortBy.splice(hix, 1);
          }
        }
        this.sortChanged = true;
        this.refreshData();
      }, 50);
    },
    headerGroupingClick(header) {
      if (!this.headerIsGrouped(header)) {
        this.sortBy = [header.value];
        this.refreshData();
        this.$nextTick(() => {
          this.groupBy = [{ key: header.value }];
        });
      }
    },
    removeGrouping() {
      this.groupBy = [];
    },
    headerIsGrouped(header) {
      return !!this.groupBy.find((g) => g.key == header.value);
    },
    getGroupedSum(item) {
      //TODO not working
      var res = [];
      var items = [];
      item.items.forEach((m) => items.push(toRaw(m)));
      this.getHeaders
        .filter((h) => h.summable)
        .forEach((h) => {
          res.push(h.text + ": " + items.map((z) => z[h.value]).sum());
        });
      if (res.length == 0) return "";
      return " " + res.join(", ");
    },
    // getHeaderGroupIcon(header) {
    //   return this.headerIsGrouped(header) ? "mdi-minus-box-multiple-outline" : "mdi-plus-box-multiple-outline";
    // },
    headerIsSorted(header) {
      return this.sortBy.indexOf(header.value) != -1;
    },
    getHeaderSortIcon(header) {
      return this.sortDesc[this.sortBy.indexOf(header.value)] ? "mdi-arrow-up" : "mdi-arrow-down";
    },
    headerNumber(header) {
      return this.sortBy.indexOf(header.value) + 1;
    },
    setFocus(on) {
      this.onfocus = on;
      if (on && !this.isLoading) this.recalcGridHeight();
    },
    setMeta(meta, err) {
      this.datatype = meta.datatype;

      this.datatype.isLoading = true;
      if (err.success && !err.message) {
        // this.queryParams = this.$route.query;
        // if (this.queryParams && this.queryParams.filter) {
        //   var h = this.datatype.headers.find((h) => h.value == this.queryParams.filter);
        //   h.filtervalues = [];
        //   var uv = DataManager.getTableItems(h.value);
        //   if (this.queryParams.filterid) {
        //     if (this.queryParams.filterid instanceof Array) {
        //       h.filtervalues = uv.filter((v) => this.queryParams.filterid.indexOf(v.Id) != -1);
        //     } else {
        //       h.filtervalues = [uv.find((v) => this.queryParams.filterid == v.Id)];
        //     }
        //   } else if (this.queryParams.filtervalues) {
        //     h.filtervalues = uv.filter((v) => this.queryParams.filtervalues.indexOf(v.toString()) != -1);
        //   }
        // }
        this.$nextTick(() => {
          // console.log(this.$refs.refGrid);
          // this.$refs.refGrid.$el.querySelector(".v-data-table__wrapper").scrollTop = this.virtualScrollerOffset; //ако си цъкнал друг таб и се върнеш
          this.$nextTick(() => {
            this.refreshData();
          });
        });
      } else {
        this.datatype.isLoading = false;
        // this.$nextTick(() => {
        //   this.dialog.showError(error.code == 401 ? "Необходимо е да влезете в системата!" : error.message);
        // });
      }
    },
    getFiltersUniqueValues(header) {
      if (header.filtertype == DataFilterType.WeekDays) {
        var days = DataManager.WeekDays.slice(0, DataManager.WeekDays.length);
        var todayIdx = new Date().getDay();
        if (todayIdx > 0) {
          var daysToStay = days.slice(todayIdx, 7);
          var daysToMove = days.slice(0, todayIdx);
          return [...daysToStay, ...daysToMove];
        } else {
          return days;
        }
      } else {
        // var distVals = this.getData.map((h) => h[header.key]).unique();
        var distVals = DataManager.getFilterDistinctValues(this.datatype, header);
        // console.log(distVals);
        return distVals ?? [];
      }
    },
    // appendFilter(filter) {
    //   DataManager.appendFilter(this.datatype, filter);
    // },
    recalcGridHeight() {
      if (this.recalcTimeout) {
        clearTimeout(this.recalcTimeout);
      }
      this.recalcTimeout = setTimeout(() => {
        if (this.$refs.refGridContainer && this.$refs.refGridContainer.clientHeight > 0) {
          this.gridHeight = this.$refs.refGridContainer.clientHeight; //-1 при ma-0, -17 при ma-2 на грид контейнера

          // this.visibleRows = Math.trunc((this.$refs.refGridContainer.clientHeight - this.headersHeight) / this.rowHeight);
          //this.gridHeight = this.headersHeight + this.visibleRows * this.rowHeight + "px";
          // if (this.hasGridHeaderSum) {
          //   this.visibleRows--; //footer
          // }
        }
        this.recalcTimeout = null;
      }, 123);
    },
    getPropText(prop) {
      return [Object.values(prop)[0]];
    },
    getTotalSum(value) {
      var val = this.getData
        .map((f) => f[value])
        .filter((f) => !!f)
        .sum();
      return isNaN(val) ? "" : val;
    },
    showExportWindow() {
      if (this.getData.length > 10000) {
        this.dialog.show(
          this.dialog.dialog_types.yes_no,
          null,
          {
            title: "Внимание",
            buttonYesText: "Да",
            buttonNoText: "Не",
            text: "Таблицата съдържа много данни и е възможно временно 'зависване' на приложението при експорта. Да продължим ли с експортирането?",
          },
          (result) => {
            if (result) {
              this.isExportWindowVisible = true;
            }
          }
        );
      } else {
        this.isExportWindowVisible = true;
      }
    },
    showContextMenu(event, item) {
      if (!this.isOnMobile) {
        event.preventDefault();
      }
      this.isContextMenuVisible = false;
      this.clickedText = event.target.innerText;
      this.mouseX = event.clientX;
      this.mouseY = event.clientY;
      this.selectedItem = item;
      this.$nextTick(() => {
        if (this.clickedText && event.button == 2) {
          setTimeout(() => {
            this.isContextMenuVisible = true;
          }, 100);
        }
      });
    },
    copyCell() {
      this.clickedText.copyToClipboard();
      g_Dialog.showInfo("Текстът е копиран.", { timeout: 2000 });
    },

    // showFilters() {
    //   this.dialog.show("filter-view", this.datatype);
    // },
    selectColumns() {
      g_Dialog.show(g_Dialog.dialog_types.column_selector, this.datatype);
      // this.dialog.show(this.dialog.dialog_types.column_selector, this.datatype);
    },

    getExportTitle() {
      return ("TremolEV_" + this.datatype.name + "_" + new Date().toTremolFpString()).replaceAll(" ", "_");
    },
    getExportData(includeTotals) {
      let headers = this.datatype.headers.filter((h) => !h.hidden);
      let rows = [];
      this.getData.forEach(function (e) {
        var r = [];
        headers.forEach((h) => r.push(DataManager.formatGridData(h, Object.byString(e, h.value))));
        rows.push(r);
      });
      if (includeTotals) {
        var r = [];
        headers.forEach((h) => r.push(h.summable ? this.formatCell(h, this.getTotalSum(h.value)) : ""));
        rows.push(r);
      }
      return { headers: headers.map((h) => h.text), rows: rows };
    },
    exportTable() {
      this.isExportWindowVisible = !this.isExportWindowVisible;
      this.dialog.show(this.dialog.dialog_types.loader, null, {
        message: "Данните се експортират, моля изчакайте...",
      });
      setTimeout(() => {
        this.exportTableAsync().then(() => {
          this.dialog.close();
        });
      }, 1000);
    },
    exportTableAsync() {
      return new Promise((resolve) => {
        var isPdf = this.exportFormat == "pdf";
        var expData = this.getExportData(isPdf);
        if (isPdf) {
          const doc = new jsPDF(expData.headers.map((h) => !h.hidden).length > 6 ? "l" : "p");
          doc.compatAPI((doc) => {
            doc.addFileToVFS("Roboto-Regular.ttf", RobotoFont.base64);
            doc.addFont("Roboto-Regular.ttf", "Roboto-Regular", "normal");
            doc.setFont("Roboto-Regular"); // set font
            doc.setFontSize(10);
            doc.autoTable(expData.headers, expData.rows, {
              styles: {
                font: "Roboto-Regular",
                fontStyle: "Roboto-Regular",
              },
              headStyles: {
                font: "Roboto-Regular",
                fontStyle: "Roboto-Regular",
              },
            });
            doc.setProperties(
              /**
               * @type {DocumentProperties}
               */
              {
                title: this.getExportTitle(),
                creator: "Tremol EV",
              }
            );
            // doc.setLanguage("bg-BG");
            // doc.putTotalPages("");
            // var data = doc.output('arraybuffer')
            // fs.writeFile(this.getExportTitle() + "." + this.exportFormat, data, resolve);
            doc.output("pdfobjectnewwindow").document.title = this.getExportTitle();

            // doc.save(this.getExportTitle() + "." + this.exportFormat, { returnPromise: true });

            setTimeout(() => {
              resolve();
            }, 100);
          });
        } else {
          var sheet = XLSX.utils.json_to_sheet([expData.headers].concat(expData.rows), {
            skipHeader: true,
          });

          // var sheet = XLSX.utils.json_to_sheet(expData.headers, { skipHeader: true });
          // expData.rows.forEach(async row => {
          //   await new Promise(res => {
          //     setTimeout(()=> {
          //       XLSX.utils.sheet_add_json(sheet,row , {
          //         skipHeader: true
          //       });
          //       setTimeout(()=> {
          //         res();
          //       }, 1);
          //     }, 1);
          //   })
          // })

          var wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, sheet);
          XLSX.writeFile(wb, this.getExportTitle() + "." + this.exportFormat); // name of the file is 'book.xlsx'
          setTimeout(() => {
            resolve();
          }, 100);
        }
      });
    },
    formatCell(header, value) {
      return DataManager.formatGridData(header, value);
    },
    getRowProps(row) {
      if (row.item == this.selectedItem) return { class: "v-data-table__selected" };
    },
    async reloadData() {
      await DataManager.loadData(this.datatype).then(() => this.refreshData());
    },
    refreshData() {
      // console.log("refreshData");
      // console.log(this.datatype.name);
      window.requestAnimationFrame(() => {
        // this.dataitems = []; // За рефреш на виртуалния скролер ?
        this.$nextTick(() => {
          this.datatype.headers.forEach((f) => {
            if (!f.hidden) f.hidden = false;
          });
          this.dataitems = DataManager.getData(this.datatype) ?? [];
          if (this.sortChanged && this.getData.length > 0) {
            this.dataitems.sort((a, b) => {
              var i = 0;
              var result = 0;
              while (i < this.sortBy.length && result === 0) {
                var sortFn = this.datatype.headers.find((h) => h.value == this.sortBy[i]).sort;
                result = sortFn(Object.byString(a, this.sortBy[i]), Object.byString(b, this.sortBy[i]));
                if (this.sortDesc[i]) result = result * -1;
                i++;
              }
              return result;
            });
            this.sortChanged = false;
          }
          // if (this.getData.length == 0) {
          //   this.message = "Няма данни за показване.";
          // } else {
          //   this.message = "";
          // }
          this.datatype.isLoading = false;
          // if (this.queryParams && this.queryParams.select) {
          //   var id = this.queryParams.select;
          //   var item = this.getData.find((d) => d.Id == id);
          //   this.selectedItem = item;
          //   this.datatype.selected = item;
          //   if (this.selectedItems.indexOf(item) == -1) this.selectedItems.push(item);
          //   this.queryParams = null;
          // }
          // if (this.$refs.refGrid && this.dataTable == null) {
          //   // console.log(this.$refs.refGrid.$el);
          //   // var dt = this.$refs.refGrid.$el.querySelector(".v-data-table__wrapper");
          //   // this.dataTable = dt;
          //   // this.dataTable.addEventListener("scroll", this.onScroll);
          // }
          // // this.$nextTick(() => {
          this.recalcGridHeight();
        });
      });
    },
  },
  watch: {
    selectedItem: function (newVal) {
      // console.log(newVal);
      this.$emit("update:modelValue", newVal);
    },
  },
  mounted() {
    // var tables = document.getElementsByTagName("table");
    // for (var i = 0; i < tables.length; i++) {
    //   resizableGrid(tables[i]);
    // }
    // function resizableGrid(table) {
    //   var row = table.getElementsByTagName("tr")[0],
    //     cols = row ? row.children : undefined;
    //   if (!cols) return;
    //   table.style.overflow = "hidden";
    //   var tableHeight = table.offsetHeight;
    //   for (var i = 0; i < cols.length; i++) {
    //     var div = createDiv(tableHeight);
    //     cols[i].appendChild(div);
    //     cols[i].style.position = "relative";
    //     setListeners(div);
    //   }
    //   function setListeners(div) {
    //     var pageX, curCol, nxtCol, curColWidth, nxtColWidth;
    //     div.addEventListener("mousedown", function (e) {
    //       curCol = e.target.parentElement;
    //       nxtCol = curCol.nextElementSibling;
    //       pageX = e.pageX;
    //       var padding = paddingDiff(curCol);
    //       curColWidth = curCol.offsetWidth - padding;
    //       if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding;
    //     });
    //     div.addEventListener("mouseover", function (e) {
    //       e.target.style.borderRight = "2px solid #0000ff";
    //     });
    //     div.addEventListener("mouseout", function (e) {
    //       e.target.style.borderRight = "";
    //     });
    //     document.addEventListener("mousemove", function (e) {
    //       if (curCol) {
    //         var diffX = e.pageX - pageX;
    //         if (nxtCol) nxtCol.style.width = nxtColWidth - diffX + "px";
    //         curCol.style.width = curColWidth + diffX + "px";
    //       }
    //     });
    //     document.addEventListener("mouseup", function () {
    //       curCol = undefined;
    //       nxtCol = undefined;
    //       pageX = undefined;
    //       nxtColWidth = undefined;
    //       curColWidth = undefined;
    //     });
    //   }
    //   function createDiv(height) {
    //     var div = document.createElement("div");
    //     div.style.top = 0;
    //     div.style.right = 0;
    //     div.style.width = "5px";
    //     div.style.position = "absolute";
    //     div.style.cursor = "col-resize";
    //     div.style.userSelect = "none";
    //     div.style.height = height + "px";
    //     return div;
    //   }
    //   function paddingDiff(col) {
    //     if (getStyleVal(col, "box-sizing") == "border-box") {
    //       return 0;
    //     }
    //     var padLeft = getStyleVal(col, "padding-left");
    //     var padRight = getStyleVal(col, "padding-right");
    //     return parseInt(padLeft) + parseInt(padRight);
    //   }
    //   function getStyleVal(elm, css) {
    //     return window.getComputedStyle(elm, null).getPropertyValue(css);
    //   }
    // }
  },
  updated() {},
  unmounted() {
    // if (this.dataTable) {
    //   try {
    //     this.dataTable.removeEventListener("scroll", this.onScroll);
    //   } catch {
    //     /** ignored */
    //   }
    // }
  },
  created() {
    // bus.$on(bus.EVENT_DataManager_DATA_CHANGED, datatype => {
    //   if (datatype == this.datatype && this.onfocus) {
    //     this.sortChanged = true;
    //     this.refreshData();
    //   }
    // });

    window.addEventListener("resize", this.recalcGridHeight);

    this.bus.on("FILTERS_CHANGED", (datatype) => {
      if (datatype == this.datatype && this.onfocus) {
        this.sortChanged = true;
        this.refreshData();
      }
    });
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.recalcGridHeight);
  },
  setup() {
    const refGrid = ref(null);
    const refGridContainer = ref(null);
    // onMounted(() => {
    //   console.log("on mounted");
    //   console.log(refGrid.value);
    // });
    return { refGrid, refGridContainer };
  },
};
</script>

<style>
.v-data-table__selected {
  background-color: v-bind(activeitembackground) !important;
}

/* .v-input__slot, */
.v-select__slot {
  display: flex !important;
  align-items: center !important;
  text-align: center !important;
  justify-content: center !important;
  vertical-align: center !important;
}

/* TODO .v-select { 
  background-color: var(--activeitembackground) !important;
} */

.data-grid-cell {
  margin: 0;
  padding: 0;
  white-space: nowrap;
  display: flex;
  height: 100%;
  min-height: 100%;
  max-height: 100%;
  width: 100%;
  align-items: center;
}

.data-grid-cell-width-divider {
  white-space: nowrap;
  display: flex;
  height: 100%;
  width: calc(100% - 1px);
  align-items: center;
}

/* .theme--light.v-data-table tbody tr.v-data-table__selected {
  background-color: var(--activeitembackground) !important;
}
.theme--dark.v-data-table tbody tr.v-data-table__selected {
  background-color: var(--activeitembackground) !important;
}
.theme--dark.v-data-table tbody tr.v-data-table__selected:hover {
  background: #a17b49c2 !important;
}
.theme--light.v-data-table tbody tr.v-data-table__selected:hover {
  background: #ffd296d2 !important; 
}*/
</style>